module.exports = __webpack_public_path__ + "img/evanhao.e219aaae.jpg";